(() => {
  const motion = matchMedia('(prefers-reduced-motion: reduce)');
  const mobile = matchMedia('(max-width: 749px)');
  const videoObserver = new IntersectionObserver(entries => {
    entries.forEach(({target: video, isIntersecting}) => {
      video.dataset.visible = String(isIntersecting);
      if (isIntersecting && !motion.matches && video.dataset.paused !== 'true') {
        if (!video.src) video.src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
        video.play().catch(() => {});
      } else video.pause();
    });
  }, {threshold: .15});
  function init(root = document) {
    root.querySelectorAll('.mg-campaign__video:not([data-initialized])').forEach(video => {
      video.dataset.initialized = 'true';
      const button = video.parentElement.querySelector('.mg-video-toggle');
      video.addEventListener('playing', () => video.classList.add('is-playing'));
      button.addEventListener('click', () => {
        const paused = !video.paused;
        video.dataset.paused = String(paused);
        if (paused) video.pause();
        else {
          if (!video.src) video.src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
          video.play().catch(() => {});
        }
        button.setAttribute('aria-pressed', String(paused));
        button.setAttribute('aria-label', paused ? button.dataset.playLabel : button.dataset.pauseLabel);
        button.firstElementChild.textContent = paused ? '▷' : 'Ⅱ';
      });
      if (motion.matches) {
        button.setAttribute('aria-pressed', 'true');
        button.setAttribute('aria-label', button.dataset.playLabel);
        button.firstElementChild.textContent = '▷';
      }
      videoObserver.observe(video);
    });
    root.querySelectorAll('[data-mg-menu-open]:not([data-initialized])').forEach(button => {
      button.dataset.initialized = 'true';
      const dialog = document.getElementById(button.getAttribute('aria-controls'));
      if (!dialog) return;
      button.addEventListener('click', () => dialog.showModal());
      dialog.querySelector('[data-mg-menu-close]').addEventListener('click', () => dialog.close());
      dialog.addEventListener('click', event => {
        const rect = dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) dialog.close();
      });
      dialog.addEventListener('close', () => button.focus());
    });
    root.querySelectorAll('.mg-footer__group').forEach(group => { group.open = !mobile.matches; });
    const sentinel = root.querySelector('.mg-header-sentinel');
    if (sentinel && !sentinel.dataset.initialized) {
      sentinel.dataset.initialized = 'true';
      new IntersectionObserver(([entry]) => {
        document.querySelector('.mg-header')?.classList.toggle('is-scrolled', !entry.isIntersecting);
      }).observe(sentinel);
    }
  }
  init();
  document.addEventListener('shopify:section:load', event => init(event.target));
  document.addEventListener('shopify:section:unload', event => event.target.querySelectorAll('video').forEach(video => videoObserver.unobserve(video)));
  mobile.addEventListener('change', () => {
    document.querySelectorAll('.mg-campaign__video').forEach(video => {
      if (!video.src) return;
      video.src = mobile.matches ? video.dataset.mobile : video.dataset.desktop;
      if (video.dataset.visible === 'true' && video.dataset.paused !== 'true' && !motion.matches) video.play().catch(() => {});
    });
    document.querySelectorAll('.mg-footer__group').forEach(group => {group.open = !mobile.matches;});
  });
  motion.addEventListener('change', () => document.querySelectorAll('.mg-campaign__video').forEach(video => {
    if (motion.matches) video.pause();
    else if (video.dataset.visible === 'true' && video.dataset.paused !== 'true') video.play().catch(() => {});
  }));
  document.addEventListener('visibilitychange', () => document.querySelectorAll('.mg-campaign__video').forEach(video => {
    if (document.hidden) video.pause();
    else if (video.dataset.visible === 'true' && video.dataset.paused !== 'true' && !motion.matches) video.play().catch(() => {});
  }));
})();
(() => {
  const key = 'mangiapia-wishlist-v1';
  let saved = [];
  try { const value = JSON.parse(localStorage.getItem(key) || '[]'); if (Array.isArray(value)) saved = value.filter(item => item && typeof item.id === 'string' && typeof item.url === 'string' && item.url.startsWith('/products/')).slice(0,100); } catch {}
  const save = () => {try {localStorage.setItem(key, JSON.stringify(saved));} catch {}};
  const sync = () => document.querySelectorAll('[data-mg-save]').forEach(button => button.setAttribute('aria-pressed', String(saved.some(item => item.id === button.dataset.productId))));
  function render() {
    const dialog = document.getElementById('mg-wishlist');
    if (!dialog) return;
    const container = dialog.querySelector('.mg-wishlist__items');
    container.replaceChildren();
    if (!saved.length) {const p = document.createElement('p');p.textContent = dialog.dataset.empty;container.append(p);}
    saved.forEach(item => {
      const row = document.createElement('div'); row.className = 'mg-wishlist__row';
      const image = document.createElement('img'); image.alt = ''; image.width = 90;image.height = 110;
      try {const url = new URL(item.image,location.origin);if (url.protocol === 'https:' && (url.hostname === location.hostname || url.hostname.endsWith('.shopify.com'))) image.src = url.href;} catch {}
      const link = document.createElement('a');link.href = item.url;link.textContent = item.title;
      const remove = document.createElement('button'); remove.type = 'button';remove.textContent = dialog.dataset.remove;
      remove.addEventListener('click', () => {saved = saved.filter(entry => entry.id !== item.id);save();sync();render();});
      row.append(image,link,remove);container.append(row);
    });
  }
  document.addEventListener('click', event => {
    const button = event.target.closest('[data-mg-save]');
    if (button) {
      event.preventDefault(); event.stopPropagation();
      const id = button.dataset.productId;
      if (saved.some(item => item.id === id)) saved = saved.filter(item => item.id !== id);
      else saved.push({id,title:button.dataset.title,url:button.dataset.url,image:button.dataset.image});
      save();sync();return;
    }
    if (event.target.closest('[data-mg-wishlist-open]')) {render();document.getElementById('mg-wishlist')?.showModal();}
    if (event.target.closest('[data-mg-wishlist-close]')) document.getElementById('mg-wishlist')?.close();
  });
  sync();
  document.addEventListener('shopify:section:load',sync);
  const observer = new MutationObserver(sync); observer.observe(document.getElementById('MainContent'),{childList:true,subtree:true});
})();
